module.exports = __webpack_public_path__ + "static/media/ether-diamond.f9374979.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/ether-diamond.gif
// module id = 133
// module chunks = 0